import React from 'react';
import Constants from '../../app.constants';

import './mocks-button.scss';

const MocksButton = ({ setShowMocks, showMocks }) => {
  const mocksButton = ['local', 'staging'].includes(Constants.ENV) ? (
    <button className="mocks-btn" onClick={() => setShowMocks(!showMocks)}>
      Mocks
    </button>
  ) : null;

  return <>{mocksButton}</>;
};

export default MocksButton;
